<ng-template #htmlTemplate>
  @for (error of listOfErrors(); track error) {
  <div class="error-text-color">{{ error }}</div>
  }
</ng-template>

@if (shouldShowErrors()) {
<div class="position error-text-color">
  <span class="sap-icon" [cpqPopover]="popoverConfig">
    &#xe1f7;
  </span>
</div>
}
